module.exports = __webpack_public_path__ + "img/default.542b39ab.jpg";